module.exports = __webpack_public_path__ + "static/media/room-5.6918b98b.jpeg";